import React from 'react';

export const formStatusContextContext = React.createContext([null, (status: any) => {}] as const);

type FormStatusContextProviderProps = {
   value: [any, (status: any) => void];
   children: React.ReactNode;
};

export const useFormStatusContext = () => {
   const value = React.useContext(formStatusContextContext);
   return value as FormStatusContextProviderProps['value'];
};

export const FormStatusContextProvider = ({value, children}: FormStatusContextProviderProps) => {
   const {Provider} = formStatusContextContext;
   return <Provider value={value}>{children}</Provider>;
};
